/**
 * @description Fetches the list of dropdown options
 */

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the list of dropdown options
 * @param {string} dropdownQuery - dropdown api query string
 * @param {string} errorStub - human readable dropdown name for error message
 * @returns {Promise<{ name: string, value: string }[]>} - a promise that resolves to the list of dropdown options
 */
const fetchDropdownOptions = (dropdownQuery, errorStub) => async () => fetch(`/referenceData/getDropdownOptions?dropdown=${ dropdownQuery }`)
  .then(decodeJson)
  .catch(({ body }) => {
    throw new ApiError(
      body ? `Error: ${ body }` : `Unable to retrieve ${ errorStub } options. Reload the page and try again`
    );
  });

export default fetchDropdownOptions;
